
import { ref, onMounted, onUnmounted, watchEffect } from 'vue';
import { mapTo, map, filter } from 'rxjs';
import { ORIGIN, GraphEngine,
         EMPTY_EFFECT, EffectSwitcher, TranslateLayerEffect, FocusLayerEffect, //TranslateLayerAndFocusBackEffect,
         SpinEffect, ElasticEffect, MovementEffect,
         PickUpEffect, DragEffect, DragAndComeBackEffect, CollisionEffect
    } from 'reactive-graphics';
import { useCanvasDimension } from '@/composition/canvas-dimension';
import { Star, StarObject } from '@/shared/star';
import LayerOverlay from '@/components/LayerOverlay.vue';
import Layer from '@/components/Layer.vue';

export default {
  components: { LayerOverlay, Layer },

    props: {
        fullcanvas: Boolean,
        points: Number,
        radius: Number,
        spin: Boolean,
        elastic: Boolean,
        xalign: { type: Number, default: 0.5 },
        yalign: { type: Number, default: 0.5 }
    },
    
    emits: [
        'frames-per-second', // emit Observable<number>
        'click-event' // emit Observable<Point>
    ],

    setup(props, { emit }) {
        const canvas = ref(null); // mismo nombre que en la plantilla (ref="canvas")
        const { dimension$ } = useCanvasDimension(canvas);
        let engine; // lazy but not reactive
        let backgroundLayer, mainLayer;

        const createBackground = (canvas, engine, radius = 10, defaultColor = null) => {
            for (let i = 0; i < 400; i++) {
                const pos = {x: -canvas.width + 3 * canvas.width * Math.random(),
                            y: -canvas.height + 3 * canvas.height * Math.random()};
                const r = Math.trunc(100 * Math.random());
                const g = Math.trunc(100 * Math.random());
                const b = 55 + Math.trunc(200 * Math.random());
                const color = defaultColor === null? `rgb(${r}, ${g}, ${b})` : defaultColor;
                const star = new Star(radius, 5, pos, color)
                engine.addGraphic(star);
                if (b > 200) engine.playEffect(new ElasticEffect(engine.frame(star), star));
                if (r > 50) engine.playEffect(new SpinEffect(engine.frame(star), star));
            }
        }

        let killedSubscription = null;

        onMounted(() => {

            engine = new GraphEngine(canvas.value);
            const framesPerSecond$ = engine.init();
            emit('frames-per-second', framesPerSecond$);
            // engine.init().subscribe(fps => emit('frames-per-second', Math.round(fps * 10) / 10));
            // const clickEvent = engine.pointer.start$.pipe(filterNoContacts, map(({ x, y }) => ({ x, y })));
            // emit('click-event', clickEvent);

            // Efectos a aplicar a diversos objetos
            const spinFx = graph => new SpinEffect(engine.frame(graph), graph, true);
            const spin2Fx = graph => new SpinEffect(engine.frame(graph), graph, false);
            const movementFx = graph => new MovementEffect(engine, graph, engine.pointer.click$);
            const dragFx = graph => new DragEffect(engine, graph);
            const dragAndComeBackFx = graph => new DragAndComeBackEffect(engine, graph);
            const pickUpFx = graph => new PickUpEffect(engine, graph);
            const collisionFx = graph => new CollisionEffect(engine.collision$, graph);
            const spinsFx = (graph) => new EffectSwitcher(engine, engine.pointer.hold$, graph, true,
                spinFx(graph), 
                EMPTY_EFFECT,
                spin2Fx(graph), //new SpinEffect(engine.frame$, graph, false),
                EMPTY_EFFECT);
            
            backgroundLayer = engine.currentLayer;
            createBackground(canvas.value, engine);
            const hold0$ = engine.pointer.hold$.pipe(engine.pointer.filterPointWithoutContact(), mapTo(ORIGIN));
            // engine.playEffect(new TranslateLayerAndFocusBackEffect(engine, 0, 1, hold0$));
            engine.playEffect(new TranslateLayerEffect(engine, 0));
            engine.playEffect(new FocusLayerEffect(engine, 0, hold0$));

            engine.nextLayer();
            createBackground(canvas.value, engine, 5, 'yellow');
            // engine.playEffect(new TranslateLayerAndFocusBackEffect(engine, backgroundLayer, 0.3, hold0$));
            engine.playEffect(new TranslateLayerEffect(engine, backgroundLayer));
            engine.playEffect(new FocusLayerEffect(engine, backgroundLayer, hold0$));

            mainLayer = engine.nextLayer();
            
            console.log(`switch to new layer ${engine.currentLayer}`);
            const center = {x: canvas.value.width * props.xalign, y: canvas.value.height * props.yalign};

            // engine.translateLayer(engine.currentLayer, center);
            // engine.rotateLayer(engine.currentLayer, Math.PI / 8);
            // engine.scaleLayer(engine.currentLayer, 0.8, 0.5);
            // engine.translateLayer(engine.currentLayer, { x: -center.x / 2, y: -center.y / 2}); //vector(center, ORIGIN));

            // Center star
            const star = new StarObject(props.radius, props.points, center, "#70CCFF");
            engine.addObject(star, movementFx, dragFx);
            if (props.spin) engine.playEffect(new EffectSwitcher(engine, engine.pointer.click$, star, true, new SpinEffect(engine.frame(star), star)));
            if (props.elastic) engine.playEffect(new EffectSwitcher(engine, engine.pointer.doubleClick$, star, true, new ElasticEffect(engine.frame(star), star)));

            // Corner stars
            const xdist = Math.min(center.x / 2, (canvas.value.width - center.x) / 2);
            const ydist = Math.min(center.y / 2, (canvas.value.width - center.y) / 2);
            const topleft = new StarObject(props.radius / 2, 5, {x: center.x - xdist, y: center.y - ydist}, "yellow");
            const bottomleft = new StarObject(props.radius / 2, 5, {x: center.x - xdist, y: center.y + ydist}, "brown");
            const topright = new StarObject(props.radius / 2, 5, {x: center.x + xdist, y: center.y - ydist}, "brown");
            const bottomright = new StarObject(props.radius / 2, 5, {x: center.x + xdist, y: center.y + ydist}, "yellow");
            engine.addObject(topleft, dragAndComeBackFx, pickUpFx, collisionFx, spinsFx);
            engine.addObject(bottomleft, dragFx, pickUpFx, collisionFx);
            engine.addObject(topright, dragFx, pickUpFx, collisionFx);
            // const dragEffect = new DragEffect(engine, topright);
            // dragEffect.drop$.subscribe(drag => console.log(`*** drop`, drag));///
            // engine.playEffect(dragEffect);
            engine.addObject(bottomright, dragAndComeBackFx, pickUpFx, collisionFx, spinsFx);

            engine.nextLayer();
            engine.addObject(new StarObject(props.radius / 2, 5, {x: center.x, y: center.y - ydist / 2}, "green"), dragAndComeBackFx, pickUpFx, collisionFx, spinsFx);

            const killed$ = engine.collision$.pipe(
            filter(([graph1, graph2]) => graph1 === star || graph2 === star),
            map(([graph1, graph2]) => graph1 === star? graph2 : graph1)
            );

            killedSubscription = killed$.subscribe(graph => {
                engine.removeObject(graph);
            });

            engine.status.removed$.subscribe(
                graph => console.log("graph removed!!!")
            );
            
            // Provoca render al redimensionar canvas
            engine.playEffect({ target: null, pulse: () => dimension$ });

            // Dibujo inicial (necesario si no se ejecutaran efectos)
            engine.requestRender();
        });

        onUnmounted(() => {
            if (killedSubscription != null) {
                killedSubscription.unsubscribe();
                killedSubscription = null;
            }
            engine.destroy();
            console.log('*** unmounted');
        });

        const paceEngine = (factor) => { engine.pace(factor); }
        const engineCurrentPace = () => { return engine.currentPace(); }
        const pauseEngine = () => { engine.pause(); };
        const enginePaused = () => { return engine.paused(); };
        const resumeEngine = () => { engine.resume(); };
        const sleepEngine = () => { engine.sleep(); };
        const engineAsleep = () => { return engine.asleep(); };

        const enableInput = () => engine.pointer.enablePointerEvents();
        const disableInput = () => engine.pointer.disablePointerEvents();
        
        const enableBackgroundLayer = () => { for (let layer = backgroundLayer; layer < mainLayer; layer++) { engine.enableLayer(layer); } };
        const disableBackgroundLayer = () => { for (let layer = backgroundLayer; layer < mainLayer; layer++) { engine.disableLayer(layer); } };
        const backgroundLayerEnabled = () => engine.layerEnabled(backgroundLayer);

        const enableMainLayer = () => engine.enableLayer(mainLayer);
        const disableMainLayer = () => engine.disableLayer(mainLayer);
        const mainLayerEnabled = () => engine.layerEnabled(mainLayer);

        return {
            canvas, 
            paceEngine, engineCurrentPace, sleepEngine, engineAsleep, pauseEngine, enginePaused, resumeEngine,
            enableInput, disableInput,
            enableBackgroundLayer, disableBackgroundLayer, backgroundLayerEnabled,
            enableMainLayer, disableMainLayer, mainLayerEnabled
        };
    }
}
